module.exports = __webpack_public_path__ + "img/wenjuanxing.6027d69d.png";